
"use client";

import { useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';
import { usePathname, useSearchParams } from 'next/navigation';

type GoogleAnalyticsProps = {
  gaId: string;
  debug?: boolean;
  trackPageViews?: boolean;
};

let initialized = false;

export function GoogleAnalytics(props: GoogleAnalyticsProps) {
  const { gaId, debug = false, trackPageViews = true } = props;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (!initialized && gaId) {
      ReactGA.initialize([{ trackingId: gaId }], { testMode: false, gaOptions: { debug_mode: debug } as any });

      initialized = true;
    }
  }, [gaId, debug]);

  useEffect(() => {
    if (!initialized || !trackPageViews) return;

    const page = `${pathname}${searchParams?.toString() ? `?${searchParams.toString()}` : ''}`;

    if (lastPathRef.current === page) return;

    lastPathRef.current = page;

    ReactGA.send({ hitType: 'pageview', page });
  }, [pathname, searchParams, trackPageViews]);

  return null;
}
